import { RestaurantResource } from '@menu/Types/Resources/RestaurantResource';

type SharedData = {
  restaurant: RestaurantResource;
  localizedMessages: Record<string, Record<string, string>>;
  isOrderMode: boolean;
  routerBase: string;
  global: {
    keys: {
      bugsnag: string;
    };
  };
};

export default (): SharedData =>
  (window as typeof window & { sharedData: SharedData }).sharedData;
